<div class="fm-admin-layout"
     [class.fm-sidebar-open]="layoutService.isSidebarOpen()"
     [class.fm-sidebar-collapsed]="layoutService.isSidebarCollapsed()">

  <!-- Sidebar -->
  <aside class="fm-admin-sidebar" id="fmAdminSidebar">
    <div class="fm-admin-logo">
      <a routerLink="/app/stories">
        <img class="fm-logo-image" src="images/logo.svg" alt="Forever Memories" />
        <img class="fm-logo-image fm-logo-icon" src="images/logo-icon.svg" alt="Logo" />
      </a>
      @if (!layoutService.isSidebarCollapsed()) {
        <button type="button" class="fm-admin-close" (click)="onSidebarToggle()" aria-label="Collapse sidebar">
          <img class="fm-svg" src="images/icons/dashboard-icons/sidebar-toggle.svg" alt="Collapse" />
        </button>
      }
    </div>

    <ul class="fm-admin-nav">
      <li>
        <a routerLink="/app/stories" routerLinkActive="active" class="fm-admin-navlink">
          <img class="fm-svg" src="images/icons/dashboard-icons/stories.svg" alt="Stories" />
          <span class="fm-menu-title">Stories</span>
        </a>
      </li>
      <li>
        <a routerLink="/app/loved-ones" routerLinkActive="active" class="fm-admin-navlink">
          <img class="fm-svg" src="images/icons/dashboard-icons/loved-ones.svg" alt="Loved Ones" />
          <span class="fm-menu-title">Loved Ones</span>
        </a>
      </li>
      <li>
        <a routerLink="/app/scheduled" routerLinkActive="active" class="fm-admin-navlink">
          <img class="fm-svg" src="images/icons/dashboard-icons/schedule-promt.svg" alt="Schedule Prompt" />
          <span class="fm-menu-title">Schedule Prompt</span>
        </a>
      </li>
      <li>
        <a routerLink="/app/storybooks" routerLinkActive="active" class="fm-admin-navlink">
          <img class="fm-svg" src="images/icons/dashboard-icons/story-book.svg" alt="Storybooks" />
          <span class="fm-menu-title">Storybooks</span>
        </a>
      </li>
      <li>
        <a routerLink="/app/legacy-qr" routerLinkActive="active" class="fm-admin-navlink">
          <img class="fm-svg" src="images/icons/dashboard-icons/legacy-qr.svg" alt="Legacy QR" />
          <span class="fm-menu-title">Legacy QR</span>
        </a>
      </li>
      <li>
        <a routerLink="/app/settings" routerLinkActive="active" class="fm-admin-navlink">
          <img class="fm-svg" src="images/icons/dashboard-icons/setting.svg" alt="Settings" />
          <span class="fm-menu-title">Settings</span>
        </a>
      </li>
    </ul>
  </aside>

  <!-- Main Area -->
  <div class="fm-admin-main">
    @if (!layoutService.hideHeader()) {
      <app-app-layout-header />
    }
    <div class="fm-content-wrapper">
      <div class="container-fluid">
        <router-outlet />
      </div>
    </div>
  </div>

  <!-- Mobile Overlay -->
  <div class="fm-admin-overlay" id="fmAdminOverlay" (click)="layoutService.close()"></div>

</div>


